import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Slider from '../utils/slider.ts';
import { Autoplay } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class OfficialPartners extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.init();
	}

	initAnimation = () => {
		const heading = this.selector.querySelector( '.raise-partner-heading' ) as HTMLElement;
		const imageBlock = this.selector.querySelector( '.official-swiper' ) as HTMLElement;
		gsap.registerPlugin( ScrollTrigger );
		let tl = gsap.timeline( {
			scrollTrigger: {
				trigger: this.selector,
				start: 'top +=70%',
				end: 'top +=30%',
			},
		} );
		tl.fromTo(
			heading,
			{
				opacity: 0,
				y: '100%',
			},
			{
				opacity: 1,
				y: 0,
				duration: 0.4,
			},
			'start',
		);
		tl.fromTo(
			imageBlock,
			{
				opacity: 0,
				y: '100%',
			},
			{
				opacity: 1,
				y: 0,
				duration: 0.4,
				delay: 0.2,
			},
			'start',
		);
	};

	init() {
		this.initAnimation();
		const sliderInit = new Slider();
		sliderInit.initCarousel( this.selector.querySelector( '.official-swiper' ) as HTMLElement, {
			spaceBetween: 0,
			slidesPerView: 'auto',
			speed: 5000,
			loop: true,
			freeMode: {
				enabled: true,
				sticky: true,
			},
			modules: [ Autoplay ],
			autoplay: { delay: 0 },
		} );
	}
}

export default OfficialPartners;
